/* ==========================================================================
   Plant Store <> UnfoldCRO — Collection source for the FBT section

   Fills the two picks (after "this item") with random products pulled from
   a merchant-picked collection. Runs before ufc-fbt.js so the base script
   picks up the injected lines the same way it reads the static ones.

   If a product has more than one available variant, a <select> is rendered
   in place of the role label — same slot Selleasy uses. Changing it updates
   the checkbox's price/compare/variant data and the visible price, then
   ufc-fbt.js re-syncs the total via its delegated change listener.

   Reshuffles on every full page load. Selleasy (if also enabled) still wins
   once its widget hydrates, since it replaces `.ufc-fbt__lines` again later.
   ========================================================================== */
(function () {
  'use strict';

  if (window.ufcFbtCollectionBound) return;
  window.ufcFbtCollectionBound = true;

  function shuffle(list) {
    var arr = list.slice();
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    return arr;
  }
   function buildSrcset(url) {
    var widths = [92, 138, 184, 260, 400, 520, 600];
    return widths
      .map(function (w) {
        return url.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w';
      })
      .join(', ');
  }

  function svgTick() {
    return (
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2"' +
      ' stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 5 5 9-11"/></svg>'
    );
  }

  function buildLine(item, roleLabel) {
    var label = document.createElement('label');
    label.className = 'ufc-fbt__line';

    var input = document.createElement('input');
    input.type = 'checkbox';
    input.checked = true;
    input.setAttribute('data-ufc-fbt-item', '');
    input.dataset.variant = item.variantId;
    input.dataset.price = item.price;
    input.dataset.compare = item.compare;
    label.appendChild(input);

    var tick = document.createElement('span');
    tick.className = 'ufc-fbt__tick';
    tick.setAttribute('aria-hidden', 'true');
    tick.innerHTML = svgTick();
    label.appendChild(tick);

       var media = document.createElement('span');
    media.className = 'ufc-fbt__media';
    if (item.image) {
      var img = document.createElement('img');
      img.src = item.image;
      img.srcset = buildSrcset(item.image);
      img.sizes = '(min-width: 990px) 260px, 46px';
      img.alt = '';
      img.loading = 'lazy';
      media.appendChild(img);
    }
    label.appendChild(media);

    var copy = document.createElement('span');
    copy.className = 'ufc-fbt__copy';

    var name = document.createElement('span');
    name.className = 'ufc-fbt__name';
    name.textContent = item.title;
    copy.appendChild(name);

    var variants = item.variants || [];
    if (item.hasVariants && variants.length > 1) {
      var select = document.createElement('select');
      select.className = 'ufc-fbt__variant';
      select.setAttribute('data-ufc-fbt-variant-select', '');
      select.setAttribute('aria-label', item.title);
      variants.forEach(function (v) {
        var opt = document.createElement('option');
        opt.value = v.id;
        opt.textContent = v.title;
        opt.dataset.price = v.price;
        opt.dataset.compare = v.compare;
        opt.dataset.priceDisplay = v.priceDisplay;
        if (String(v.id) === String(item.variantId)) opt.selected = true;
        select.appendChild(opt);
      });
      copy.appendChild(select);
    } else {
      var role = document.createElement('span');
      role.className = 'ufc-fbt__role';
      role.textContent = roleLabel;
      copy.appendChild(role);
    }

    label.appendChild(copy);

    var price = document.createElement('span');
    price.className = 'ufc-fbt__price';
    price.setAttribute('data-ufc-fbt-price-display', '');
    price.textContent = item.priceDisplay;
    label.appendChild(price);

    return label;
  }

  function init() {
    var root = document.querySelector('[data-ufc-fbt]');
    if (!root || root.getAttribute('data-ufc-fbt-use-collection') !== 'true') return;

    var dataEl = document.querySelector('[data-ufc-fbt-collection]');
    if (!dataEl) return;

    var pool;
    try {
      pool = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!pool || !pool.length) return;

    var picks = shuffle(pool).slice(0, 2);
    if (!picks.length) return;

    var lines = root.querySelector('.ufc-fbt__lines');
    if (!lines) return;

    var roleLabel = root.getAttribute('data-ufc-fbt-role-label') || '';

    // Drop everything after the locked "this item" line — the static
    // editor picks — and rebuild from the random selection.
    var locked = lines.querySelector('.ufc-fbt__line.is-locked');
    while (locked && locked.nextSibling) {
      lines.removeChild(locked.nextSibling);
    }

    var frag = document.createDocumentFragment();
    picks.forEach(function (item) {
      var plus = document.createElement('span');
      plus.className = 'ufc-fbt__plus';
      plus.setAttribute('aria-hidden', 'true');
      plus.textContent = '+';
      frag.appendChild(plus);
      frag.appendChild(buildLine(item, roleLabel));
    });
    lines.appendChild(frag);

    // The lines just changed under ufc-fbt.js's feet — its own
    // MutationObserver on .ufc-fbt__lines picks this up and re-syncs.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();